import { DataGrid } from '@v2/components/ui/DataGrid';
import React from 'react';
import {
  fieldCellRenderer,
  fromCellRenderer,
  toCellRenderer,
} from '../renderers';

type DataGridColumnsType = React.ComponentProps<typeof DataGrid>['columns'];

export const reviewEditsColumns = [
  {
    field: 'id',
    headerName: 'ID',
    width: 100,
    sortable: false,
  },
  {
    field: 'name',
    headerName: 'Ad Group',
    minWidth: 300,
    flex: 1,
    sortable: false,
  },
  {
    field: 'field',
    headerName: 'Field',
    width: 120,
    sortable: false,
    renderCell: fieldCellRenderer,
  },
  {
    field: 'from',
    headerName: 'From',
    minWidth: 200,
    flex: 1,
    sortable: false,
    renderCell: fromCellRenderer,
  },
  {
    field: 'to',
    headerName: 'To',
    minWidth: 150,
    sortable: false,
    renderCell: toCellRenderer,
  },
  {
    field: 'errorState',
    valueGetter: (_, row) => {
      if (row.result?.body?.updated_fields) return 'SUCCESS';
      return 'ERROR';
    },
    headerName: 'Error State',
    sortable: false,
  },
] as DataGridColumnsType;
